import {useEffect, useState, useRef} from 'react';
import DataFlow from './DataFlow';
import { getFlowPathStyles } from './FlowPath_style.js';


const FlowPath = ({fromRef, toRef, containerRef}) => {
    const [path, setPath] = useState('');
    const pathRef = useRef(null);
    const styles = getFlowPathStyles();


    const updatePath = () => {
        const fromEl = fromRef.current;
        const toEl = toRef.current;
        const containerEl = containerRef.current;

        if (fromEl && toEl && containerEl) {
            const fromRect = fromEl.getBoundingClientRect();
            const toRect = toEl.getBoundingClientRect();
            const containerRect = containerEl.getBoundingClientRect();

            let x1, y1, x2, y2;

            // Determine connection strategy based on box positions
            const horizontalOverlap = fromRect.right > toRect.left;

            if (horizontalOverlap) {
                // Boxes overlap horizontally - connect top/bottom
                const fromIsAbove = fromRect.bottom < toRect.top;

                if (fromIsAbove) {
                    // Connect bottom of start box to top of end box
                    x1 = fromRect.left + (fromRect.width / 2) - containerRect.left;
                    y1 = fromRect.bottom - containerRect.top;
                    x2 = toRect.left + (toRect.width / 2) - containerRect.left;
                    y2 = toRect.top - containerRect.top;
                } else {
                    // Connect top of start box to bottom of end box
                    x1 = fromRect.left + (fromRect.width / 2) - containerRect.left;
                    y1 = fromRect.top - containerRect.top;
                    x2 = toRect.left + (toRect.width / 2) - containerRect.left;
                    y2 = toRect.bottom - containerRect.top;
                }

                // Use vertical curves for top/bottom connections
                setPath(`M${x1},${y1} C${x1},${y1 + (y2 - y1) / 2} ${x2},${y2 - (y2 - y1) / 2} ${x2},${y2}`);

            } else {
                // No horizontal overlap - connect left/right (standard case)
                x1 = fromRect.right - containerRect.left;
                y1 = fromRect.top + (fromRect.height / 2) - containerRect.top;
                x2 = toRect.left - containerRect.left;
                y2 = toRect.top + (toRect.height / 2) - containerRect.top;

                // Use horizontal curves for left/right connections
                setPath(`M${x1},${y1} C${x1 + (x2 - x1) / 2},${y1} ${x2 - (x2 - x1) / 2},${y2} ${x2},${y2}`);
            }
        }
    };

    useEffect(() => {
        const timer = requestAnimationFrame(updatePath);

        const handleResize = () => requestAnimationFrame(updatePath);
        window.addEventListener('resize', handleResize);

        return () => {
            cancelAnimationFrame(timer);
            window.removeEventListener('resize', handleResize);
        };
    }, [fromRef, toRef, containerRef, updatePath]);


    return (
        <>
            <svg
                style={styles.container}
            >
                <path
                    ref={pathRef}
                    d={path}
                    strokeWidth="3"
                    fill="none"
                    style={styles.path}
                />
            </svg>
            <DataFlow 
                pathElement={pathRef.current} 
                containerRef={containerRef}
                active={path !== ''}
            />
        </>
    );
}

export default FlowPath;